<template>
    <div class="bottom-nav">
        <router-link to="/dashboard" v-slot="{ isActive }">
            <span>
                <i class="fa fa-house" :class="{ 'active-icon': isActive }"></i>
            </span>
            <small>Dashboard</small>
        </router-link>

        <router-link to="/expenses" v-slot="{ isActive }" v-if="userType != 'usertype22' && userType != 'usertype24' && userType != 'usertype23'">
            <span>
                <i class="fa fa-file-invoice-dollar" :class="{ 'active-icon': isExpensesActive }"></i>
            </span>
            <small>Expenses</small>
        </router-link>

        <router-link to="/meetings" v-slot="{ isActive }" v-if="assetType!='Household' && userType != 'usertype22' && userType != 'usertype24' && userType != 'usertype23'">
            <span><i class="fa fa-calendar-alt" :class="{ 'active-icon': isActive }"></i></span>
            <small>Meetings</small>
        </router-link>

        <router-link to="/chore-rotation" v-slot="{ isActive }" v-else-if="userType != 'usertype22' && userType != 'usertype24' && userType != 'usertype23'">
            <span><i class="fa-solid fa-clipboard-check" :class="{ 'active-icon': isActive }"></i></span>
            <small>Chores</small>
        </router-link>

        <router-link to="/voting-proposals" v-slot="{ isActive }" v-if="isCompanyLlc">
            <span><i class="fa-solid fa-check-to-slot" :class="{ 'active-icon': isActive }"></i></span>
            <small>Votes</small>
        </router-link>

        <router-link to="/ticket" :class="{ 'router-link-active': isTicketsActive }" v-else-if="assetType!='Household'">
            <span><i class="fa fa-wrench" :class="{ 'active-icon': isTicketsActive }"></i></span>
            <small>Tickets</small>
        </router-link>

      

        <router-link to="/expenses/dues" v-slot="{ isActive }" v-else>
            <span><i class="fa-solid fa-credit-card" :class="{ 'active-icon': isTicketsActive }"></i></span>
            <small>Pay Bills</small>
        </router-link>
        <router-link to="/manage-events"
                     v-if="showEInviteInNav">
            <span>
                <i class="fa-solid fa-calendar-check"></i>
            </span>
            <small>eInvite</small>
        </router-link>





        <a v-if="showCommunicationInNav && userType != 'usertype22' && userType != 'usertype24' && userType != 'usertype23'"
           title="Communication"
           href="#!"
           @click="openCommunication">
            <span class="for-icon"><i class="fa fa-comments"></i></span>
            <small>Chat</small>
        </a>
        <router-link v-if="userType == 'usertype22'"
                     title="Notification" to="/ManageNotification">
            <span class="for-icon"><i class="fa fa-bell"></i></span>
            <small>Notification</small>
        </router-link>
        <a v-if="showPendingVerificationInNav"
           title="Pending Verification"
           href="#!"
           @click="onPendingVerificationClick">
            <span class="for-icon"><i class="fa fa-hourglass-half"></i></span>
            <small>Pending</small>
        </a>
    </div>
</template>

<script>
    import UserService from '@/service/user.service';
    import SimpleDialog from '@/views/shared/SimpleDialog.vue';
    import { createConfirmDialog } from 'vuejs-confirm-dialog';
    import {
        applyVerificationApiResult,
        canShowCommunicationModule,
        getUcaasVerificationStatus,
        runUcaasVerification,
        shouldShowPendingVerificationButton
    } from '@/helpers/ucaasVerification';

    export default {
        name: 'MobileBottomNav',

        data() {
            return {
                companyId: localStorage.getItem('companyId') || '',
                assetType: localStorage.getItem('assetType'),
                userType: localStorage.getItem('userType') || '',
                ucaasVerificationState: getUcaasVerificationStatus()
            };
        },

        computed: {
            isCompanyLlc() {
                return this.assetType === 'Companies & LLCs';
            },
            isTicketsActive() {
                return this.$route.path === '/ticket' || this.$route.path.startsWith('/viewTicket/');
            },
            isExpensesActive() {
                return this.$route.path.startsWith('/expenses');
            },
            showEInviteInNav() {
                return ['usertype22', 'usertype23', 'usertype24']
                    .includes(String(this.userType || '').toLowerCase());
            },
            isCommunicationCompanyExcluded() {
                return this.companyId === '29E9C4AD-9AF2-4757-A001-AC34690B1A12';
            },
            showCommunicationInNav() {
                void this.ucaasVerificationState;
                return !this.isCommunicationCompanyExcluded && canShowCommunicationModule(this.userType);
            },
            showPendingVerificationInNav() {
                void this.ucaasVerificationState;
                return !this.isCommunicationCompanyExcluded && shouldShowPendingVerificationButton(this.userType);
            }
        },
        created() {
            this.userType = localStorage.getItem('userType');
        },
        methods: {
            openCommunication() {
                const fullUrl = UserService.getUrlForDynamic();
                if (!fullUrl) {
                    this.$toast.error('Communication URL or key is missing.');
                    return;
                }
                window.open(fullUrl, '_blank', 'noopener,noreferrer');
            },
            onPendingVerificationClick() {
                const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                    question: 'Communication account verification is pending.\n\nDo you want to continue the verification process?',
                    header: 'Pending Verification',
                    cancel: 'Cancel',
                    confirm: 'Continue'
                });
                onConfirm(() => {
                    this.continueUcaasVerification();
                });
                reveal();
            },
            async continueUcaasVerification() {
                try {
                    const response = await runUcaasVerification(this.userType);
                    const body = response?.data || {};
                    this.ucaasVerificationState = applyVerificationApiResult(body.verificationStatus);

                    if (body.success && String(body.verificationStatus || '').toLowerCase() === 'completed') {
                        this.$toast.success('UCaaS verification completed.');
                        return;
                    }

                    this.$toast.info('UCaaS verification is still pending.');
                } catch (error) {
                    this.$toast.error(error?.message || 'Unable to process UCaaS verification.');
                }
            }
        }
    };
</script>
